<script>
import html2canvas from "html2canvas";
import { mapActions } from "vuex";

export default {
    props: {
        graphComponent: {
            required: true,
            type: [Object, Function]
        },

        graphFileName: {
            required: true,
            type: String
        },

        selectedSurveyID: {
            required: true,
            type: Number
        },

        language: {
            required: true,
            type: String,
        },
    },

    methods: {
        ...mapActions("results", [
            "uploadReportGraph"
        ]),

        convertCanvasToFile(canvas, filename) {
            return new Promise((resolve, reject) => {
                try {
                    canvas.toBlob((blob) => {
                        const file = new File([blob], filename, { type: "image/png" });
                        resolve(file);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

        sendToBackend(screenshotFile) {
            const formData = new FormData();
            formData.append("files", screenshotFile);
            formData.append("user_id", this.$user.user_id);
            formData.append("company_id", this.$user.company_id);
            formData.append("survey_id", this.selectedSurveyID);
            formData.append("language", this.language || 'en');
            this.uploadReportGraph(formData)
                .then(() => {
                    this.$notify('success', this.$t('myReports.misc.graph_confirmed'), true);
                    this.$emit('onSuccess');
                })
                .catch(() => {
                    this.$notify('error', this.$t('myReports.misc.graph_not_confirmed'), true);
                    this.$emit('onError');
                })
        },

        takeGraphScreenshot() {
            const containerElement = this.$refs.graphcontainer;
            let name = this.graphFileName;
            
            if (this.language === 'tr') {
                let parts = name.split('.');
                parts[0] = parts[0].concat('_tr');
                name = parts.join('.');
                console.log(name);
            }

            html2canvas(containerElement)
                .then((canvas) => {
                    this.convertCanvasToFile(canvas, name)
                        .then((file) => {
                            this.sendToBackend(file);
                        });
                });
        },
    }
}
</script>

<template>
    <div ref="graphcontainer">
        <component :is="graphComponent" :selectedSurveyID="selectedSurveyID" :language="language" />
    </div>
</template>

<style lang='scss' scoped>

</style>